import { DateHelper } from '../../components/Limits/types';

const MINUTES = 1_000;

const limitFormat = (
  value: string | number = '',
  { f, format }: { f: DateHelper; format: string }
): string => {
  if (!value) {
    return '';
  }

  return f.getDateTime({ date: +value * MINUTES }).toFormat(format);
};

export default limitFormat;
